var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageTo > 0)?_c('span',[_vm._v(_vm._s(1 + _vm.pageFrom)+" - "+_vm._s(_vm.pageTo)+" of "+_vm._s(_vm.totalItems))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }